import { render, staticRenderFns } from "../configAssignation/configAssignation.html?vue&type=template&id=92a0df4e&scoped=true&external"
import script from "../configAssignation/configAssignation.js?vue&type=script&lang=js&external"
export * from "../configAssignation/configAssignation.js?vue&type=script&lang=js&external"
import style0 from "../configAssignation/configAssignation.css?vue&type=style&index=0&id=92a0df4e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a0df4e",
  null
  
)

export default component.exports